var BaseProperty = require("../BaseProperty");

/** Специальная стрелка для связи Class с NameIndividuals*/
module.exports = (function () {

	var o = function (graph) {
		BaseProperty.apply(this, arguments);

		var that = this,
			superDrawFunction = that.draw,
			owlClass,
			label = "Individual of";

		this.draw = function (labelGroup) {
			that.labelVisible(!graph.options().compactNotation());
			return superDrawFunction(labelGroup);
		};

		// Disallow overwriting the label
		this.label = function (p) {
			if (!arguments.length) return label;
			return this;
		};

		this.owlClass = function (p) {
			if (!arguments.length) return owlClass;
			owlClass = p;
			return this;
		};

		this.linkType("dotted")
			.markerType("white")
			.styleClass("subclass")
			.type("owl:NamedIndividual");

        // that.baseIri("http://www.w3.org/2000/01/rdf-schema#");
        // that.iri("http://www.w3.org/2000/01/rdf-schema#subClassOf");

    };
	o.prototype = Object.create(BaseProperty.prototype);
	o.prototype.constructor = o;

	return o;
}());
